import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const Api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded.exp < Date.now() / 1000;
    } catch {
        return true;
    }
};

Api.interceptors.request.use((config) => {
    const token = localStorage.getItem('@MonitorNogleApp:token');

    if (token && isTokenExpired(token)) {
        localStorage.removeItem('@MonitorNogleApp:token');
        localStorage.removeItem('@MonitorNogleApp:user');
        localStorage.removeItem('@MonitorNogleApp:userName');
        window.location.href = '/login';
        return Promise.reject(new Error('Token expirado'));
    }

    return config;
});

export const exceptionNotificationAPI = (error, toast) => {
    if (/500/.test(error.message)) {
        console.error('Failed to connect Web Service (500).');
    } else if (/404/.test(error.message)) {
        console.error('Route Not Found (404).');
    } else if (/401/.test(error.message)) {
        sessionStorage.clear();
        localStorage.removeItem('@MonitorNogleApp:token');
        localStorage.removeItem('@MonitorNogleApp:user');
        localStorage.removeItem('@MonitorNogleApp:userName');

        window.location.href = "/";
    } else if (/400/.test(error.message)) {
        let notifications = error.response.data.errors;
        if (notifications && notifications.length > 0) {
            notifications.forEach((not) => {
                console.log(not);
            })
        }
    } else {
        console.error(error.message);
    }
}

export default Api;
